<template>
    <div class="IperMatrizPeligrosDireccion">
        {{ direccion }}
    </div>
</template>

<script>
export default {
    name: "IperMatrizPeligrosDireccion",

    props: {
        direccion: String
    }
}
</script>